import React from 'react';
import { Heading } from '..';
import css from '../../containers/ListingPage/ListingPage.module.css';

import { GiFarmTractor } from 'react-icons/gi';
import { FaBox, FaCouch, FaBoxOpen } from 'react-icons/fa6';
import { MdOutlineRoomPreferences } from 'react-icons/md';
import { FaHome } from 'react-icons/fa';
import { PiBuildingApartmentFill, PiParkDuotone } from 'react-icons/pi';
import { MdOutlinePrivateConnectivity } from 'react-icons/md';
import { MdOutlineSpaceDashboard } from 'react-icons/md';

// Shared display data for both cleaning and kennel types
const accommodationDisplayData = {
  // luxury: {
  //   name: 'Luxury',
  //   icon: <FaCouch />,
  // },
  in_home: {
    name: 'Independent house',
    icon: <FaHome />,
  },
  apartment: {
    name: 'Apartment',
    icon: <PiBuildingApartmentFill />,
  },
  // dedicated_room: {
  //   name: 'Dedicated Room',
  //   icon: <MdOutlineRoomPreferences />,
  // },
  // farm_stay: {
  //   name: 'Farm Stay',
  //   icon: <GiFarmTractor />,
  // },
  // crate_free: {
  //   name: 'Crate-Free',
  //   icon: <FaBoxOpen />,
  // },
  // outdoor: {
  //   name: 'Outdoor',
  //   icon: <PiParkDuotone />,
  // },
  // crate_based: {
  //   name: 'Crate-Based',
  //   icon: <FaBox />,
  // },
  // private_room: {
  //   name: 'Private Room',
  //   icon: <MdOutlinePrivateConnectivity />,
  // },
  // shared_space_with_partition: {
  //   name: 'Shared Space with Partition',
  //   icon: <MdOutlineSpaceDashboard />,
  // },
};

const SectionAccommodationType = props => {
  const { heading, selectedOptions } = props;

  const normalizedOptions = Array.isArray(selectedOptions)
    ? selectedOptions
    : selectedOptions
    ? [selectedOptions]
    : [];

  if (!heading || normalizedOptions.length === 0) {
    return null;
  }

  return (
    <section className={css.sectionCleaningFacilities}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>
      <ul className={css.cleaningFacilitiesList}>
        {normalizedOptions
          .filter(option => accommodationDisplayData[option])
          .map(option => {
            const facility = accommodationDisplayData[option];
            return (
              <li key={option} className={css.multiEnumItem}>
                <span className={css.facilityIcon}>{facility?.icon}</span>
                <span>{facility?.name || option}</span>
              </li>
            );
          })}
      </ul>
    </section>
  );
};

export default SectionAccommodationType;
